<template>
    <el-container>
        <el-aside :style="{width:aside+'%'}" >
            <div class="logo">
                <span><img src="./assets/logo.png" alt="" @click="Hide"></span>
                <span>亿星</span>
            </div>
            <el-menu
                :default-active="defalut"
                :router="false"
                @select="handleSelect"
            >
                <el-menu-item
                    v-for="{name, icon, router} in menus"
                    :key="router"
                    :index="router">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="'#icon--'+icon"></use>
                    </svg>
                    {{name}}
                </el-menu-item>
                <el-menu-item index="fapiao">
                    <svg class="icon" aria-hidden="true">
                        <use :xlink:href="'#icon--'+'pifashichang-xuanzhong'"></use>
                    </svg>
                   新版本
                </el-menu-item>
            </el-menu>
        </el-aside>

        <el-container>
            <el-header>
                <img v-show="!isShow" class="sousuo" src="./assets/缩回菜单-01.png" alt="" @click="Hide"/>
                <img v-show="isShow" class="sousuo" src="./assets/展现菜单-01.png" alt="" @click="Shows"/>
                <el-card>
                    <el-popover
                        placement="bottom-end"
                        width="100"
                        trigger="hover"
                        popper-class="avatar_pop"
                    >
                        <div class="avatar_pop_content">
                            <span @click="logout">退出登录</span>
                        </div>
                        <div slot="reference" class="avatar">
                            <!--<img src="./assets/header/avatar.png" alt=""/>-->
                            <img src="./assets/admin.jpg" alt=""/>
                            <span>{{user_name}}</span>
                            <i class="el-icon-arrow-down"></i>
                        </div>
                    </el-popover>
                </el-card>
            </el-header>

            <el-main>
                <slot>
                    <keep-alive>
                        <router-view v-if="$route.meta.keepAlive"></router-view>
                    </keep-alive>
                    <router-view v-if="!$route.meta.keepAlive"></router-view>
                </slot>
            </el-main>
        </el-container>
            <transition name="el-zoom-in-bottom">
                <div v-show="show2" class="transition-box">
                    <div style="background-color:#f56c31;height: 35px;line-height: 35px;text-align: center;color: white">
                        消息提示
                        <i  class="el-icon-error" style="float: right;margin-top: 10px;color:#fff;margin-right:10px;font-size: 15px" @click="show2 = false"></i>
                    </div>
                    <div class="tanchuan">新增订单:{{new_order}}</div>
                    <div class="tanchuan">新增派单:{{new_paid}}</div>
                    <!--<div class="tanchuan" ><el-button type="text" style="color: #F56C31;" @clock="go">立刻前往>></el-button></div>-->
                </div>
            </transition>
    </el-container>
</template>

<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import { menus , menus2} from './utils/config';
    import { session_id } from './stores/api';
    import ElRow from "element-ui/packages/row/src/row";

    export default {
        components: {ElRow},
        data () {
            let path = window.location.hash.replace('#/', '');
            if (path.indexOf('SupplyChain') >= 0) {
                path = 'SupplyChain';
            } else if (path.indexOf('OrderList') >= 0) {
                path = 'OrderLists';
            }
            return {
                isShow: false,
                show2: false,
                defalut: path,
                menus: menus2,
                user_type: '',
                arr: '',
                user_name: localStorage.getItem('user_name'),
                new_paid: '',
                new_order: '',
                aside: 13,
            };
        },
        async beforeMount () {
            await this.getProvinceList();      //全局获取一次省份存入store
            await this.getUserInfo();           //获取个人信息
        },
        created () {
            this.show()
            this.getuser()
        },
        methods: {
            ...mapMutations(['setUserInfoTab']),
            ...mapActions(['getProvinceList', 'getUserInfo']),
            go () {
              // this.$router.push({path: 'OrderList2'})
            },
            show () {
                this.$http.get(this.$reqUrl + `service.php?act=check_order`).then(res => {
                    if (res.data.new_orders !== '0' || res.data.new_paid !== '0') {
                        this.show2 = true
                        this.new_paid = res.data.new_paid
                        this.new_order = res.data.new_orders
                        setTimeout(() => { this.show2 = false }, 10000)
                    }
                })
                // console.log('ss')
            },
            Hide() {
                this.isShow = !this.isShow
                this.aside = 0
            },
            Shows() {
                this.isShow = !this.isShow
                this.aside = 13
            },
            handleSelect (index, indexPath) {
                console.log(index);
                if (index === 'fapiao') {
                    window.open('/gdeton/#/Mendian')
                } else if (window.location.hash.indexOf(index) < 0) {
                    this.$router.push('/' + index);
                }
            },
            logout () {
                window.localStorage.removeItem('shouhou_session_id');
                // window.location.href = this.$reqUrl+'user.php';
                this.$router.push({path: '/'})
            },
            //获取user_type
            getuser(c) {
                if (localStorage.getItem('role_id') === '8') {
                    this.menus = menus
                    // console.log('我在这')
                } else {
                    this.menus = menus2;
                    this.arr=localStorage.getItem('role').split(",");
                    // console.log(this.arr);
                    var a=this.menus;
                    var b=this.arr;
                    function  FilterData(a,b)
                    {   //循环判断数组a里的元素在b里面有没有，有的话就放入新建立的数组中
                        var result = new Array();
                        var c=b.toString();
                        for(var i=0;i<a.length;i++)
                        {
                            if(c.indexOf(a[i].router.toString())>-1)
                            {
                                result.push(a[i]);
                            }
                        }
                        return result;
                    }
                    this.menus = FilterData(a,b)
                }
                this.$http.get(this.$reqUrl + 'user.php?act=profile&session_id=' + session_id)
                .then(res => {
                    this.user_type = res.data.userinfo.user_type
                    this.arr = res.data.userinfo.position
                    console.log(res.data)
                    c&&c();
                })
                .catch(res => {
                    // console.log(res)
                })
            },
            //判断user_type
            // getUser_type() {
                // var user_type = localStorage.getItem('user_type');
                // var position = localStorage.getItem('position');
                // console.log(this.arr)
                // if(this.user_type==1){
                //     this.menus = menus;
                // }else if(this.user_type==3){
                //     this.menus = menus2;
                // }else if(this.user_type==2){
                //     this.menus = menus;
                //     this.arr=this.arr.split(",");
                //     var a=this.menus;
                //     var b=this.arr;
                //     function  FilterData(a,b)
                //     {   //循环判断数组a里的元素在b里面有没有，有的话就放入新建立的数组中
                //         var result = new Array();
                //         var c=b.toString();
                //         for(var i=0;i<a.length;i++)
                //         {
                //           if(c.indexOf(a[i].router.toString())>-1)
                //           {
                //           result.push(a[i]);
                //           }
                //         }
                //         return result;
                //     }
                //     this.menus = FilterData(a,b)
                //     console.log(this.menus)
                // }
            // }
        },
        computed: {
            ...mapState(['userInfo'])

        },
        mounted() {
            setInterval(this.show, 60000)
            // this.getuser(()=>{this.getUser_type()})
        }
    };
</script>
<style lang="less" scoped>
    @import "default";
    .transition-box {
        position: fixed;
        bottom: 30px;
        right: 30px;
        width: 350px;
        height: 200px;
        border-radius: 4px;
        background-color: #fff;
        text-align: center;
        color: #f56c31;
        box-sizing: border-box;
        border: 1px solid #f56c31;
        margin-right: 20px;
        opacity: 0.9;
        z-index: 999;
        .tanchuan{
            margin-top: 20px;
            font-size: 18px;
        }
    }
    .sousuo{
        position: absolute;
        cursor: pointer;
        margin-left: 25px;
        top: 25px;
        width: 30px;
        height: 30px;
    }
    @headHeight: 80px;
    .logo {
        height: @headHeight;
        display: flex;
        align-items: center;
        color: #FFF;
        font-size: 30px;
        font-weight: bold;
        letter-spacing: 20px;
        & > span:nth-child(1) {
            flex: 0.35;
            img {
                width: 56px;
                height: 36px;
                margin-right: 10px;
                float: right;
            }
        }
        & > span:nth-child(2) {
            flex: 0.6;
        }
    }

    .el-container {
        height: 100%;
        .el-header {
            height: @headHeight !important;
            padding: 0;
            font-size: 16px;
            z-index: 1;
            .el-card {
                height: 100%;
                /deep/ .el-card__body {
                    height: 100%;
                    padding: 0 40px;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    & > img {
                        width: 22px;
                        height: 24px;
                        cursor: pointer;
                    }
                    .divider {
                        height: 40px;
                    }
                    .avatar {
                        display: inline-flex;
                        align-items: center;
                        cursor: pointer;
                        & > img {
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                        }
                        & > span {
                            margin: 0 10px;
                        }
                        & > i {
                            font-size: 12px;
                        }
                    }
                }
            }

            .divider {
                display: inline-block;
                height: 16px;
                border-left: 1px solid rgba(199, 204, 212, 0.8);
                margin: 0 24px;
            }

        }
        .show {
            width: 15% !important;
        }
        .hide {
            width: 5%;
        }
        .el-aside {
            /*width: 15% !important;*/
            background: #292b2e;
            .el-menu {
                background: #292b2e;
                border: 0;
                .el-menu-item {
                    font-size: 16px;
                    color: #FFF;
                    border-left: 3px solid #292b2e;
                    &:hover, &:focus, &.is-active {
                        background: #0e1014;
                        border-color: @orange;
                        .icon {
                            fill: @orange;
                        }
                    }

                    .icon {
                        width: 40px;
                        height: 20px;
                        fill: #FFF;
                    }
                }

            }
        }
        .el-main {
            padding: 35px 45px;
            background: #fafafa;
        }
    }


</style>
<style lang="less">
    .avatar_pop {
        margin-top: 25px !important;
        width: 200px !important;
        padding: 0 !important;
        .avatar_pop_content {
            display: flex;
            flex-direction: column;
            & > span {
                text-align: center;
                font-size: 14px;
                line-height: 45px;
                cursor: pointer;
                &:hover {
                    background: #2795f5;
                    color: #FFF;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/Container.vue